export default __webpack_public_path__ + "static/media/Foto-19.ffd3c7fe.png";